import React, { useEffect, useRef } from 'react';
import './TheFitzpatrickScale.scss';
import person1 from '../../assets/scale/person1.png';
import person2 from '../../assets/scale/person2.png';
import person3 from '../../assets/scale/person3.png';
import person4 from '../../assets/scale/person4.png';
import person5 from '../../assets/scale/person5.png';
import person6 from '../../assets/scale/person6.png';
import person1M from '../../assets/scale/person1M.png';
import person2M from '../../assets/scale/person2M.png';
import person3M from '../../assets/scale/person3M.png';
import person4M from '../../assets/scale/person4M.png';
import person5M from '../../assets/scale/person5M.png';
import person6M from '../../assets/scale/person6M.png';
import color1 from '../../assets/scale/color1.png';
import color2 from '../../assets/scale/color2.png';
import color3 from '../../assets/scale/color3.png';
import color4 from '../../assets/scale/color4.png';
import color5 from '../../assets/scale/color5.png';
import color6 from '../../assets/scale/color6.png';

function TheFitzpatrickScale() {
  const type1 = useRef();
  const type2 = useRef();
  const type3 = useRef();
  const type4 = useRef();
  const type5 = useRef();
  const type6 = useRef();
  const chart = [
    {
      photoD: person1,
      photoM: person1M,
      color: color1,
      desc1: 'Light, pale white',
      desc2: 'Always burns, never tans',
      ref: type1
    },
    {
      photoD: person2,
      photoM: person2M,
      color: color2,
      desc1: 'White, fair',
      desc2: 'Usually burns, tans with difficulty',
      ref: type2
    },
    {
      photoD: person3,
      photoM: person3M,
      color: color3,
      desc1: 'Medium, white to olive',
      desc2: 'Sometimes mild burn, gradually tans to olive',
      ref: type3
    },
    {
      photoD: person4,
      photoM: person4M,
      color: color4,
      desc1: 'Olive, moderate brown',
      desc2: 'Rarely burns, tans with ease to a moderate brown',
      ref: type4
    },
    {
      photoD: person5,
      photoM: person5M,
      color: color5,
      desc1: 'Brown, dark brown',
      desc2: 'Very rarely burns, tans very easily',
      ref: type5
    },
    {
      photoD: person6,
      photoM: person6M,
      color: color6,
      desc1: 'Black, very dark brown to black',
      desc2: 'Never burns, tans very easily, deeply pigmented',
      ref: type6
    }
  ];
  useEffect(() => {
    const type1C = type1.current;
    const type2C = type2.current;
    const type3C = type3.current;
    const type4C = type4.current;
    const type5C = type5.current;
    const type6C = type6.current;
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.rootBounds.width <= 768) {
            if (entry['isIntersecting'] === true) {
              if (entry['intersectionRatio'] > 0.5) {
                entry.target.style.opacity = '1';
              }
            }
          }
        });
      },
      { threshold: [0, 0.5] }
    );
    observer.observe(type1C);
    observer.observe(type2C);
    observer.observe(type3C);
    observer.observe(type4C);
    observer.observe(type5C);
    observer.observe(type6C);

    return () => {
      observer.unobserve(type1C);
      observer.unobserve(type2C);
      observer.unobserve(type3C);
      observer.unobserve(type4C);
      observer.unobserve(type5C);
      observer.unobserve(type6C);
    };
  }, []);

  return (
    <section className="scale">
      <h3 className="scale__title title">The Fitzpatrick Scale</h3>
      <div className="scale__chart">
        {chart.map((type, i) => {
          return (
            <div className="types" ref={type.ref} key={i}>
              <picture className="types__photo">
                <source srcSet={type.photoD} media="(min-width: 769px)" />
                <source srcSet={type.photoM} media="(max-width: 768px)" />
                <img alt="portrait of a woman representing the scale" src={type.photoM} />
              </picture>
              <div className="types__desc">
                <img
                  className="types__desc__color"
                  alt="color pallet representing the scale"
                  src={type.color}
                />
                <div className="types__desc__text">
                  <p className="types__desc__text--title">Type {i + 1}</p>
                  <p className="types__desc__text--copy">{type.desc1}</p>
                  <p className="types__desc__text--copy">{type.desc2}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default TheFitzpatrickScale;
